<div class="border rounded-lg overflow-hidden flex items-start p-2 gap-2 w-full h-full bg-white cursor-pointer hover:shadow-sm transition-shadow" (click)="goToDetails()">
  <!-- Texto -->
  <div class="flex-1 flex flex-col min-w-0">
    @if (name) {
      <h3 class="m-0 text-sm sm:text-base font-semibold line-clamp-2">
      {{ name }}
      </h3>
      @if (year) {
        <p class="m-0 text-xs sm:text-sm text-gray-500">
          {{'::Harvest' | abpLocalization}} {{ year }}
        </p>
      }
    }

    <p class="text-xs sm:text-sm text-gray-500 flex items-center gap-1 mb-0">
      @if (flagUrl) {
      <img [src]="flagUrl" alt="" class="w-4 h-4 rounded-full object-cover" />
      }
      {{ location }}
    </p>
    <!-- winepassport#364 (WP-018) — visible para todos (antes solo logueados), así un visitante
         sabe que el vino está agotado antes de entusiasmarse con la ficha. -->
    @if (stock <= 0) {
    <p class="text-xs sm:text-sm mt-1 mb-1">
      <span class="inline-block bg-red-100 text-red-700 px-2 py-0.5 rounded font-semibold">{{'::Catalog:OutOfStockBadge' | abpLocalization}}</span>
    </p>
    } @else if (isAuthenticated) {
    <p class="text-xs sm:text-sm text-gray-700">
      {{'::InStock' | abpLocalization}}: {{ stock }} / {{'::MaxOrder' | abpLocalization}}: {{ maxOrder }}
    </p>
    } @else {
    <div class="h-2" aria-hidden="true"></div>
    }
    <div [class.mt-auto]="stock > 0">
      <div class="flex items-center gap-1">
        <span
          class="inline-block w-16 text-center bg-metro-blue text-metro-secondary px-1 py-1 rounded-lg font-bold text-xs sm:text-sm min-w-[6rem]">
          $ {{ price | number:'1.0-0'}}
        </span>
        <button
          type="button"
          class="inline-flex items-center justify-center w-10 h-10 min-w-0 rounded-full bg-transparent text-metro-blue transition hover:text-metro-blue focus:outline-none cursor-pointer"
          [class.opacity-40]="stock <= 0"
          [class.cursor-not-allowed]="stock <= 0"
          [disabled]="stock <= 0"
          (click)="onCatalogAddToCart($event)"
          [attr.aria-label]="'::AddToCart' | abpLocalization">
          <span class="relative inline-flex">
            @if (isAdding) {
              <span class="inline-flex h-5 w-5 rounded-full border-2 border-metro-blue border-t-transparent border-l-transparent animate-spin" aria-hidden="true"></span>
            }
            @else {
              <app-metro-icon [svg]="addToCartIcon" size="18"></app-metro-icon>
            }
          </span>
        </button>
      </div>
    </div>
  </div>

  <!-- Imagen -->
  <div class="flex-shrink-0 ml-4 h-full flex items-center justify-center">
    <div class="w-28 h-28 flex items-center justify-center relative">
  <img
    [src]="imageUrl || 'assets/images/no-image.png'"
    [alt]="name"
    class="max-h-full max-w-full object-contain rounded transition-opacity duration-700"
    [class.opacity-0]="!imageLoaded"
    [class.opacity-100]="imageLoaded"
    (load)="imageLoaded = true"
    (error)="onImageError($event)"
  />

  <!-- Skeleton -->
  @if (!imageLoaded && !hasError) {
    <div class="absolute inset-0 bg-gray-200 animate-pulse rounded"></div>
  }

    </div>
  </div>
</div>
